import Types from '../Types';

export default {
  attemptFindUsers: (payload) => ({
    type: Types.FIND_USERS_ATTEMPT, payload
  }),
  attemptFindUserLevels: () => ({
    type: Types.FIND_USER_LEVELS_ATTEMPT
  }),
  attemptFindOneUser: (payload) => ({
    type: Types.FIND_ONE_USER_ATTEMPT,
    payload: payload
  }),
  attemptEditProfile: (payload) => ({
    type: Types.EDIT_PROFILE_ATTEMPT,
    payload: payload
  }),
  attemptSaveUser: (payload) => ({
    type: Types.SAVE_USER_ATTEMPT,
    payload: payload
  }),
  attemptRemoveUser: (payload) => ({
    type: Types.REMOVE_USER_ATTEMPT,
    payload
  }),
  attemptVerify: () => ({
    type: Types.VERIFY_ATTEMPT
  }),
  attemptLogin: (payload) => ({
    type: Types.LOGIN_ATTEMPT,
    payload: payload
  }),
  attemptLogout: () => ({
    type: Types.LOGOUT_ATTEMPT
  }),
  attemptSignup: (payload) => ({
    type: Types.SIGNUP_ATTEMPT,
    payload: payload
  }),
  attemptForgotPassword: (payload) => ({
    type: Types.FORGOT_PASSWORD_ATTEMPT,
    payload: payload
  }),
  attemptSetNewPassword: (payload) => ({
    type: Types.SET_NEW_PASSWORD_ATTEMPT,
    payload: payload
  }),
  attemptNotifyPayment: (payload) => ({
    type: Types.NOTIFY_PAYMENT_ATTEMPT,
    payload: payload
  }),
  attemptFindWishlist: (payload) => ({
    type: Types.FIND_WISHLIST_ATTEMPT,
    payload
  }),
  attemptAddToWishlist: (payload) => ({
    type: Types.ADD_TO_WISHLIST_ATTEMPT,
    payload
  }),
  attemptRemoveFromWishlist: (payload) => ({
    type: Types.REMOVE_FROM_WISHLIST_ATTEMPT,
    payload
  }),
  attemptFindGiveaways: (payload = {}) => ({
    type: Types.FIND_GIVEAWAYS_ATTEMPT,
    payload
  })
}



/** WEBPACK FOOTER **
 ** ./src/redux/user/userActions.js
 **/